// extracted by mini-css-extract-plugin
module.exports = {"alert-description":"style_alert-description__XcLWg"};